import { AccomodationTranslation } from "./accomodation-translation.model";
import { CardInfoTranslation } from "./card-info-translation.model";

export class AccomodationFirstChildren {
   /*
   *
   */
    constructor(
        public accomodation?: AccomodationTranslation,
        public otherActiveAccomodation?: number, 
        public children?:CardInfoTranslation[]
    ){}
    
}